import { initializeDataWorkers } from "./DataWorkerManager.ts";
import { initializeRenderWorkers } from "./RenderWorkerManager.ts";

export function enableWorkers() {
    // Initialize both worker types independently
    initializeDataWorkers();
    initializeRenderWorkers();
}


